export const STUDY_DRUG_ITEMS = [
  {
    type: "text",
    translatable: true,
    description:
      "appText.dietDiary.addMeal.frequentlyForgottenItems.studyDrug.description.item1",
  },
  {
    type: "text",
    translatable: true,
    description:
      "appText.dietDiary.addMeal.frequentlyForgottenItems.studyDrug.description.item2",
  },
  {
    type: "text",
    translatable: true,
    description:
      "appText.dietDiary.addMeal.frequentlyForgottenItems.studyDrug.description.item3",
  },
  {
    type: "text",
    translatable: true,
    description:
      "appText.dietDiary.addMeal.frequentlyForgottenItems.studyDrug.description.item4",
  },
  {
    type: "text",
    translatable: true,
    description:
      "appText.dietDiary.addMeal.frequentlyForgottenItems.studyDrug.description.item5",
  },
];

export const FOOD_DRINK_ITEMS = [
  {
    type: "multi-text",
    translatable: true,
    title:
      "appText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.beverages.title",
    description: [
      "appText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.beverages.description",
    ],
  },
  {
    type: "multi-text",
    translatable: true,
    title:
      "appText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.condiments.title",
    description: [
      "appText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.condiments.description",
    ],
  },
  {
    type: "multi-text",
    translatable: true,
    title:
      "appText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.cookingIngredients.title",
    description: [
      "appText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.cookingIngredients.description",
    ],
  },
  {
    type: "multi-text",
    translatable: true,
    title:
      "appText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.quickSnacks.title",
    description: [
      "appText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.quickSnacks.description",
    ],
  },
  {
    type: "multi-text",
    translatable: true,
    title:
      "appText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.consumingCornstarchGlycosade.title",
    description: [
      "appText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.consumingCornstarchGlycosade.description.item1",
      "appText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.consumingCornstarchGlycosade.description.item2",
    ],
  },
];
